/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

const secondsInMinute = 60;
const secondsInHour = 60 * secondsInMinute;
const secondsInDay = 24 * secondsInHour;
const secondsInWeek = 7 * secondsInDay;

export enum TimeUnitsInSeconds {
    Minute = secondsInMinute,
    Hour = secondsInHour,
    Day = secondsInDay,
    Week = secondsInWeek,
}
